export default [
  {
    id: 1,
    name: '负责人'
  },
  {
    id: 2,
    name: '学习产品负责人'
  },
  {
    id: 3,
    name: '服务负责人'
  },
  {
    id: 4,
    name: '会籍负责人'
  },
  {
    id: 5,
    name: '小组负责人'
  },
  {
    id: 6,
    name: '顾问'
  },
  {
    id: 7,
    name: '外宣财务负责人'
  }
]
